import React from 'react'
import { css } from '@emotion/core'
import PersonTimelineItem from './PersonTimelineItem/PersonTimelineItem'
import useLifeEvents from '../../../../../../../../wcf/AppWcf/components/Timeline/helpers/useLifeEvents'
import findParents from '../../../../../../../../wcf/AppWcf/components/Timeline/helpers/findParents'

const cssPersonTimelineDetails = css`
  max-width: 600px;
  font-size: 16px;
  list-style-type: none;
`

export default function PersonTimelineDetails({ personData, tree = [] }) {
  const { lifeEvents, deathYear } = useLifeEvents({
    personData,
    ...findParents(tree, personData),
  })

  return (
    <>
      <ul css={cssPersonTimelineDetails} className="fs-timeline">
        {lifeEvents.map((timelineItem) => (
          <PersonTimelineItem
            key={`event - ${timelineItem.date} -${timelineItem.place}-${timelineItem.eventType} `}
            ribbonText={timelineItem.event.toLowerCase()}
            spouseName={null}
            year={timelineItem.year}
            gender={personData.gender}
            age={timelineItem.age}
            deathYear={deathYear}
            event={timelineItem.event}
            eventType={timelineItem.eventType}
            description={timelineItem.description}
          />
        ))}
      </ul>
    </>
  )
}

PersonTimelineDetails.propTypes = {}
